import { KeyboardKeys } from '../browser-constants/keyboard-keys';

const isShortcutKeyOnly = function (event, key) {
  if (!event || typeof event.key !== 'string') {
    return false;
  }

  const currentKey = event.key.toUpperCase();

  return (
    window.document.activeElement.nodeName !== 'TEXTAREA' &&
    window.document.activeElement.nodeName !== 'INPUT' &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey &&
    !event.metaKey &&
    currentKey !== KeyboardKeys.valueOperatingSystem &&
    currentKey === key
  );
};

export { isShortcutKeyOnly };
